import { Ability, AbilityBuilder } from '@casl/ability'
//import { defineAbilitiesFromPrivileges } from './defineAbilities';
//import type { AppAbility, Actions, Subjects } from './defineAbilities';
import type { User } from '@/apiServices/types';
import { LoggedUserService } from '@/services/LoggedUserService';
import { AbstractPeriodicTask } from '@/generics/AbstractPeriodicTask';
import { ability, type AppAbility } from '@/ability'

class AbilityServiceClass extends AbstractPeriodicTask {

  //-----------------------------------------------------------------------------------------------
  private constructor(refreshInterval: number = 30) {
    super(refreshInterval); // start periodic refresh automatically
  }

  //-----------------------------------------------------------------------------------------------
  // Singleton instance
  static instance: AbilityServiceClass = new AbilityServiceClass();

  //-----------------------------------------------------------------------------------------------
  public static getInstance(): AbilityServiceClass {
    return AbilityServiceClass.instance;
  }

  //-----------------------------------------------------------------------------------------------
  public getAbility(): AppAbility {
    return ability;
  }
  //-----------------------------------------------------------------------------------------------

  public async getAbilityAsync(): Promise<AppAbility> {
    if (!ability.rules || ability.rules.length === 0) {
      await this.forceRefresh();
    }
    return ability;
  }

  //-----------------------------------------------------------------------------------------------
  public setPrivileges(privileges: Array<{ action: string; subject: string }>) {
    const newAbility = this.defineAbilitiesFromPrivileges(privileges);
    ability.update(newAbility.rules);
  }
  //-----------------------------------------------------------------------------------------------
  public static extractUserPrivileges(user: User): Array<{ action: string; subject: string }> {
    const privileges: Array<{ action: string; subject: string }> = [];
    user.userRoleAssignments.forEach((assignment) => {
      const tenant = assignment.tenant;
      assignment.role.rolePrivileges.forEach((priv) => {
        privileges.push({
          action: priv.privilegeName,
          subject: tenant,
        });
      });
    });
    return privileges;
  }

  //-----------------------------------------------------------------------------------------------
  //-----------------------------------------------------------------------------------------------
  // This method is called periodically by PeriodicTask
  protected async run(): Promise<void> {
    const user: User | null = await LoggedUserService.getUserAsync();

    if (!user || !user.isActive) {
      this.setPrivileges([]);
      return;
    }

    const privileges = AbilityServiceClass.extractUserPrivileges(user);
    this.setPrivileges(privileges);
  }
  //-----------------------------------------------------------------------------------------------
  protected defineAbilitiesFromPrivileges(privileges: Array<{ action: string; subject: string }>): AppAbility {
    const { can, rules } = new AbilityBuilder<AppAbility>(Ability)

    const hasWildcard = privileges.some(p => p.action === '*')

    if (hasWildcard) {
      // Full access — super admin
      can('manage', 'all')
    } else {
      for (const p of privileges) {
        // Use both action & subject
        can(p.action, p.subject)
      }
    }

    // Create a new ability instance with these rules
    return new Ability(rules)
  }
  //-----------------------------------------------------------------------------------------------
}

//-----------------------------------------------------------------------------------------------
// Export singleton instance
export const AbilityService = AbilityServiceClass.getInstance();
export { ability } from '@/ability';
